import { all, call, put, takeLatest } from 'redux-saga/effects';
import { statisticsActions } from '$store/statistics/index';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { LoadStatisticsContentAction } from '$store/statistics/interface';
import { batchActions } from '$store';

function* loadStatisticsItemsWorker() {
  try {
    const data = yield call(Api.get, '/stats/dates');
    const all = yield call(Api.get, '/stats/all');

    yield put(
      batchActions(
        statisticsActions.setStatisticsItems(data.dates),
        statisticsActions.setStatisticsContent({
          date: 0,
          content: all.dates,
        }),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* loadStatisticsContentWorker(action: LoadStatisticsContentAction) {
  const { date } = action.payload;

  try {
    const data = yield call(Api.get, `/stats/date/${date}`);

    yield put(
      statisticsActions.setStatisticsContent({
        date,
        content: data.dates,
      }),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* statisticsSaga() {
  yield all([
    takeLatest(statisticsActions.loadStatisticsItems, loadStatisticsItemsWorker),
    takeLatest(statisticsActions.loadStatisticsContent, loadStatisticsContentWorker),
  ]);
}
